$(document).ready(function(){
  
  $('.site-header__icons-wrapper a.open_form').click(function(){
	$('.site-header__icons-wrapper .header_search').css("display", "block");
  });
  
  $('.ds_slider_home').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    slide: "li"
  });
  
  
  var acc = document.getElementsByClassName("ds-accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight){
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }
  

  function equalizer(){
    var max = -1;
    $(".pro_image a figure img").css('min-height', '300px'); 	
    $(this).each(function() {

      var minHeight = $(this).innerHeight();
      max = minHeight > max ? minHeight : max;

    });
    $(this).css('min-height',max) 
  }

  jQuery(document).ready(function() {
    equalizer();
  });

  jQuery(window).resize(function() {
    equalizer();
  });
  
});
/*
$(window).load(function(){
  if(typeof(Storage) !== "undefined") {
    if(sessionStorage.newsletter_popup == 'true'){
    }
    else{
      sessionStorage.newsletter_popup = 'true';
      setTimeout(function () {
        if( $.cookie("newsletter") == 'hide_newsletter' ){
        }
        else{
          $("#newsletter-popup").modal('show');
        }
      }, 5000);
    }
  }
});

$(document).on("change", "#newslatter_btn", function () {
  if ($(this).prop('checked') == true){
    $.cookie("newsletter", "hide_newsletter", { expires: 1 });
  }
});*/